<template>
  <v-chart :options="options" />
</template>

<script>
import { DEFAULT_COLORS } from '@/constants';
import chartable from '@/mixins/chartable';

export default {
  mixins: [chartable],
  props: {
    values: {
      type: Array,
      required: true,
    },
    colors: {
      type: Array,
      default() {
        return DEFAULT_COLORS;
      },
    },
    animation: {
      type: Boolean,
      default: true,
    },
    areaStyle: {
      type: String,
      default: 'normal',
    },
  },
  computed: {
    options() {
      return {
        animation: this.animation,
        color: this.colors,
        grid: {
          left: '5%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: this.values.map(value => value.name),
          axisTick: { alignWithLabel: true },
          axisLabel: {
            fontWeight: 'normal',
            fontSize: 9,
            color: '#bbbbaa',
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            fontWeight: 'normal',
            fontSize: 9,
            color: '#bbbbaa',
          },
        },
        tooltip: {
          trigger: 'item',
          transitionDuration: 0,
          formatter: '{b} : {c}',
          textStyle: {
            fontSize: 12,
          },
        },
        series: this.series,
      };
    },
    series() {
      return [
        {
          type: 'bar',
          barWidth: '40%',
          data: this.itemStyle(this.values),
        },
      ];
    },
  },
  methods: {
    itemStyle(values) {
      return values.map((val, index) => {
        return {
          ...val,
          itemStyle: (() => {
            let style = {};
            if (this.areaStyle == 'gradation') {
              style = this.areaStyleGradation(this.colors[index]);
            } else if (this.areaStyle == 'linearGradient') {
              style = this.areaStyleLinearGradient(this.colors[index], 20, 40);
            } else if (this.areaStyle == 'spinLinearGradient') {
              style = this.areaStyleSpinLinearGradient(this.colors[index], 20, 40);
            }
            return style;
          })(),
        };
      });
    },
  },
};
</script>
